import { SalesforceField } from 'model/SalesforceField';
import Checkbox from 'components/Generic/Forms/FormFields/FormCheckbox';
import React from 'react';
import { useFormContext } from 'components/Generic/Forms/SalesforceIntegratedForms/FormContext';

const SalesforceCheckBox = ({ fields, stepName }: SalesforceField) => {
  const { updateFormData, updateSummary } = useFormContext();
  const handleChange = (value: boolean): void => {
    updateFormData({ fieldName: fields.salesforceFieldId.value, value });
    updateSummary({
      fieldValue: value,
      fieldName: {
        storeName: fields.salesforceFieldId.value,
        displayName: fields.title.value,
      },
      stepName: stepName,
    });
  };
  return (
    <div className="salesforce-checkbox">
      <Checkbox
        required={fields.isRequired.value}
        onChange={handleChange}
        slots={{
          label: <p className="body-small">{fields.title.value}</p>,
          error: <p className="body-small">This field is required</p>,
        }}
      />
    </div>
  );
};

export default SalesforceCheckBox;
